module.exports = __webpack_public_path__ + "img/bg_nubi_light.a7c64e54.jpg";